module.exports = __webpack_public_path__ + "img/828.717c1378.png";